<template>
    <div>
        <button class="ds-btn" @click.prevent="handleOvpFormGenerate">Ģenerēt OVP formas</button>
    </div>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex';
   
    import * as ovpStoreTypes from '../../../vuex/modules/ovp/ovp.store-types';
    import * as companyStoreTypes from '../../../vuex/modules/company/company.store-types';

    export default {
        name: 'users-ovp-job-conditions-generate',
        components: {},
        data: () => ({isModalVisible: false}),
        computed: {
            ...mapGetters('company', {
                /** @type {Company|*} */
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
            ...mapGetters('ovp', {
                 /** @type {function|*} */
                selectedUsers: ovpStoreTypes.GET_SELECTED_OVP_USERS,
            }),
        },
        methods: {
            ...mapActions('ovp', {
                /** @type {function|*} */
                generateOvpForms:  ovpStoreTypes.ACTION_GENERATE_OVP_FORMS,
            }),
            async handleOvpFormGenerate() {
                const isValid = await this.$parent.validate();

                if (!isValid || !Object.values(this.selectedUsers).length) {
                    return;
                }

                try {
                     //For template categories currentCompany._id will be empty
                    await this.generateOvpForms({companyId: this.currentCompany._id, selectedUsers: this.selectedUsers});

                    this.$parent.reset();
                } catch (error) {
                    this.$parent.setErrors({[error.field]: [error.message]});
                }
               
            }
        },
    }
</script>